import { Controller } from "@hotwired/stimulus";
import { Wheel } from "spin-wheel/src/wheel";

const itemBackgroundColours = [
    "#e8336a",
    "#ee743b",
    "#95c11f",
    "#15af97",
    "#0085c8",
    "#005580",
    "#7a4d99"
];

function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export default class extends Controller {
    static get values() {
        return {
            prizes: Array,
            centreImage: String,
            overlayImage: String,
            textColours: Array,
            segmentColours: Array,
            prizeId: Number
        }
    }

    static get targets() {
        return ["wheelContainer", "resultContainer", "spinTheWheelButton", "completeButton"];
    }

    renderWheel() {
        const items = this.prizesValue;//.map(p => ({ label: p.name }));

        this.wheelContainerTarget.wheel = new Wheel(
            this.wheelContainerTarget,
            {
                isInteractive: true,
                itemBackgroundColors: this.segmentColoursValue,
                itemLabelAlign: "left",
                itemLabelBaselineOffset: 0,
                itemLabelColors: this.textColoursValue,
                itemLabelFontSizeMax: 44,
                itemLabelFont: 'Poppins, Helvetica, sans-serif',     
                itemLabelRadius: 0.93,
                itemLabelRadiusMax: 0.1,
                itemLabelRotation: 180,
                items: items,
                overlayImage: this.overlayImageValue,
                image: this.centreImageValue,
                lineColor: "#fff",
                lineWidth: 4,
                onRest: e => this.showResult(e),
                onSpin: e => this.spinToPrize(e),               
                radius: 0.84,
                rotationResistance: -100,
                rotationSpeedMax: 500
            }
        );
    }

    spinToPrize(e) {
        const isManualSpin = e.target === this.spinTheWheelButtonTarget;

        if (isManualSpin || e.method === "interact") {
            this.spinTheWheelButtonTarget.disabled = true;
            this.wheelContainerTarget.wheel.isInteractive = false;
            var nonWinningItems = this.prizesValue.map((item, index) => ({ item: item, index: index })).filter(p => p.item.value === 0);
            this.wheelContainerTarget.wheel.spinToItem(
                this.prizeIdValue ?
                    this.prizesValue.findIndex(p => p.value === this.prizeIdValue) :
                    nonWinningItems[Math.floor(Math.random() * nonWinningItems.length)].index,
                randomIntFromInterval(2500, 4000),
                false,
                randomIntFromInterval(2, 4),
                isManualSpin || e.rotationSpeed > 0 ? 1 : -1,
                null
            );
        }
    }

    showResult() {
        setTimeout(
            () => {
                this.spinTheWheelButtonTarget.classList.add("d-none");
                this.resultContainerTarget.classList.remove("d-none");
                this.completeButtonTarget.classList.remove("d-none");
            },
            250
        );
    }
}